const CATEGORIES = {
  'BLANCO': ['#ffffff'],
  'BLANCO PUNTA AMARILLA': ['#ffffff', '#f5c518'],
  'AMARILLO': ['#f5c518'],
  'AMARILLO PUNTA VERDE': ['#f5c518', '#1a7303'],
  'VERDE': ['#1a7303'],
  'VERDE PUNTA AZUL': ['#1a7303', '#0412d4'],
  'AZUL': ['#0412d4'],
  'AZUL PUNTA ROJA': ['#0412d4', '#cc0606'],
  'ROJO': ['#cc0606'],
  'ROJO PUNTA NEGRA': ['#cc0606', '#111111'],
  'PRIMER DAN': ['#111111'],
  'SEGUNDO DAN': ['#111111'],
  'TERCER DAN': ['#111111'],
  'CUARTO DAN': ['#111111'],
  'QUINTO DAN': ['#111111'],
  'SEXTO DAN': ['#111111'],
  'SEPTIMO DAN': ['#111111'],
  'OCTAVO DAN': ['#111111'],
  'NOVENO DAN': ['#111111'],
};

export default CATEGORIES;
